<template>
  <div class="h5" style="padding-top: 50px;">
    <div class="banner">
      <div class="text">
        <p>当高效的浏览速度侵蚀用户体验</p>
        <p>的时候，互联网迎来新一轮的革新，</p>
        <p>扁平化的设计风格推动着HTML5及CSS3的盛行。</p>
      </div>
      <img src="../../static/h5/banner.png" alt />
    </div>
    <p class="ys">HTML5的优势</p>
    <div class="h5s">
      <Row>
        <div class="h5text">
          <p class="h5-text" style="height: 8%;">1.HTML5开发速度快，一端开发多端运行</p>
          <p class="h5-text">
            2.如果APP用户常见页面频换，如（淘宝首页各种不同活动），
            那么用H5，维护起来更容易
          </p>
          <p class="h5-text">
            3.如果app中出现大量文字且格式比较丰富（比如加粗、字体
            大小，图文展示）等用H5比较方便
          </p>
          <p class="h5-text">
            4.迭代版本时，不需要打包便可以发布（实时更新、快速迭代），
            与云端实现实时数据交互
          </p>
        </div>
        <Col span="14" offset="9">
          <img class="logo1" src="../../static/h5/logo1.png" alt />
        </Col>
      </Row>
    </div>
    <p class="ys">HTML5手机站开发概述</p>
    <div class="gs">
      <Row>
        <Col span="16" offset="4">
          <p class="gs-text">
            html5app开发就是html5开发语言制作的移动手机网站。移动站点顾名思义，就是指一切用移动终端访问的网络站点（通常指网站），像通常用的手机、pad（平板电脑）等都属于移动终端。
            传统常会称呼移动站点为wap网站即手机网页站。
          </p>

          <p
            class="gs-text"
          >html5是一门网页前端开发技术，经历过html2、html3、html4、xhtml、html5等大体的几个阶段，现在html5为最新的前端技术，通过它能实现相对比较炫的效果。</p>
          <p class="gs-text">
            html5 本身就是就是移动应用平台，具有移动应用平台所需的所有元素，是近十年来web开发标准最巨大的飞跃。和以前的版本不同是html5并非仅仅用来表示web容，它的新使命是将web带入
            一个成熟的应用平台，在html5平台上，视频、音频、图象、动画、以及同手机或电脑的交互都被标准化。
          </p>
        </Col>
      </Row>
    </div>
    <div class="jishu">
      <p class="ys">HTML5技术优点</p>
      <div class="jishu-text">
        <Row>
          <Col span="16" offset="4">
            <p class="yd-text">1、给站点带来了更多的多媒体元素(视频和音频);</p>
            <p class="yd-text">2、静态的页面开始动起来，视觉效果更炫，提高了用户体验度;</p>
            <p class="yd-text">3、添加了几个新的标签控件：提高了标签的语义性、提升了加载速度;</p>
            <p class="yd-text">4、被大量应用于移动应用程序和游戏：不需要第三方插件、不需要插件就能支持iOS设备、突破常规浏览器游戏限制;</p>
            <p class="yd-text">
              5、可以很好的替代Flash和Silverlight，可以直接播放视频，不必安装Flash插件，除去网站因Flash打开慢的不友好的一面;以往Flash的网站开发开始转向HTML5，Flash网站不利于搜索引擎收录，
              HTML5技术，当涉及到网站的抓取和索引的时候，对于SEO很友好;
            </p>
            <p class="yd-text">6、跨平台部署运行：可以共用一个UI代码库，节省几倍的开发时间;</p>
            <p class="yd-text">7、跨浏览器兼容性好：可以快速查询DOM、遍历Java并深入研究网络堆栈;</p>
          </Col>
        </Row>
        <p class="ys">HTML5发展趋势</p>
        <div class="qs">
          <Row>
            <Col span="16" offset="4">
              <p class="qs-text">1、移动优先</p>
              <span>
                从如今层出不穷的移动应用就知道，在这个智能手机和将平板电脑大爆炸的时代，移动优先已成趋势，不管是开发什么，都以移动为主。许多游戏开发商也将在移动web应用中扮演中重要角色，
                移动web应用优先的趋势将会持续到移动设备统治信息处理领域。
              </span>
              <p class="qs-text">2、开发速度快</p>
              <span>html已存在多年，开发技术成熟，也为html手机站的开发速度提供了一定的保证，如果说开发一个app需要至少2个月，那么一个html手机站只需要一半不到的时间。</span>
              <p class="qs-text">3、响应式设计&自动变化的屏幕尺寸</p>
              <span>在html5真的改变移动开发平台之前，必须要迈出重要一步，那就是“响应式设计”，也就是屏幕可以根据内容而自动调整大小。</span>
              <p class="qs-text">4、设备访问</p>
              <span>
                消除web应用与原生应用界限的最大障碍就是浏览器访问移动设备基本特性的能力，利用html5实现此能力方面，比如能与云更好地整合（这有利于应用内购买，消息推送等）并提高游戏可玩性，
                有了html5这个平台，开发商可以不再依赖于java语言，css3，html及其它程序语言。
              </span>
              <p class="qs-text">5、离线缓存</p>
              <span>
                离线缓存算是比较新的一个概念，简单来说就是在离线情况下，web应用还可以正常运行。传统意义上的web应用需要依赖于网络，而HTML5的离线缓存可以冲破这个束缚，利用离线缓存技术，
                可以在离线状态下正常使用web应用。目前已经有产品实现了这个方式。
              </span>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <!-- <img src="../../static/image/htmls5.jpg" class="fullWidth"> -->
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
export default {
  name: "htmls",
  data() {
    return {};
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qs-text {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 5%;
}
.qs {
  margin-bottom: 10%;
}
.jishu {
  width: 100%;
  /* height: 600px; */
  background: url(../../static/h5/bg.png) no-repeat;
  background-size: 100%;
}
.jishu-text {
  margin-top: 5%;
}
.yd-text {
  margin-top: 3%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.yd-text:nth-child(7) {
  margin-bottom: 5%;
}
.gs {
  margin-top: 5%;
}
.gs-text {
  margin-top: 3%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.ys {
  margin-top: 5%;
  font-size: 36px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  text-align: center;
  padding-bottom: 5%;
}
.h5s {
  width: 100%;
  position: relative;
  margin-top: 10%;
}
.h5text {
  height: 75%;
  top: -40%;
  left: 20%;
  position: absolute;
  width: 40%;
  border: 1px solid rgba(51, 51, 51, 1);
}
.h5-text:nth-child(1) {
  height: 1%;
}
.h5-text {
  height: 8%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
  margin: 5% 10%;
}
.logo1 {
  margin-top: 9%;
  width: 70%;
}
.banner {
  width: 100%;
}
.text {
  margin-top: 20%;
  width: 100%;
}
.banner > .text > p {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
}
.banner > .text {
  position: absolute;
}
.banner > img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/htmls.vue